import { useContext, createContext } from 'react';
import { Service } from '~/types/models';
import useCurrentTeam from './use-current-team';
import { Plan } from '~/types/plans';

export const PlansContext = createContext<BonjoroStatic['plans']>(
  window.Bonjoro?.plans
);

const usePlans = () => {
  return useContext(PlansContext);
};

export const useVmPlan = () => {
  const plans = usePlans();

  return plans.find(
    (plan) => plan.service == Service.VideoMessaging || plan.service == null
  )!;
};

export const useTmPlan = (): Plan | null => {
  const plans = usePlans();

  return plans.find(
    (plan) => plan.service == Service.Testimonials || plan.service == null
  )!;
};

export const canSwitchBillingCycle = (service?: Service) => {
  const vmPlan = useVmPlan();
  const tmPlan = useTmPlan();
  const plans = usePlans();

  const { on_legacy_plan: onLegacyPlan } = useCurrentTeam();

  if (onLegacyPlan || plans.length == 1) return true;

  /**
   * If the other plan is free, allow user to switch billing cycle.
   */
  if (service == Service.VideoMessaging) {
    return tmPlan?.isFreePlan ?? false;
  }

  return vmPlan.isFreePlan;
};

export default usePlans;
